import backend, {AGENTCORE_ENGINE_API, METRICS_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const getMetricsUrl = (path, queryParam) => {
  if (!METRICS_API) {
    throw new Error('REACT_APP_METRICS_API is not configured.');
  }

  const query = queryString.stringify(queryParam);

  return `${METRICS_API}${path}?${query}`;
};

const queryDailyClientMetrics = (dates) => {
  const url = getMetricsUrl('/metrics/client/daily_count', {
    dates: dates.join(','),
  });
  return backend.get(url);
};

const queryDailyClientLogsMetrics = (dates) => {
  const url = getMetricsUrl('/metrics/client/daily_logs', {
    dates: dates.join(','),
  });
  return backend.get(url);
};

// Returns {dates, snapshots} where snapshots hold the full financial snapshot
// records (forecast/actual weeks keyed by GGGGWeekWW) sorted by metricDate descending.
const queryFinancialSnapshots = (dates) => {
  const url = getMetricsUrl('/metrics/financial/snapshot', {
    dates: dates.join(','),
  });
  return backend.get(url);
};

// Returns the per-client monthly financial snapshot for a single metric date and
// calendar month: {metricDate, month, clients, totals, lastEvaluatedKey}. The backend
// owns every derived figure (weighted hours, estimated revenue, break/holiday/rounding
// rules), so callers must render its fields as-is rather than recomputing them.
// Pass the lastEvaluatedKey returned by a previous page to fetch the next page.
const queryClientMonthlyFinancialSnapshot = ({date, month, lastEvaluatedKey} = {}) => {
  if (!date) {
    throw new Error('date is required to query the client monthly financial snapshot.');
  }

  if (!month) {
    throw new Error('month is required to query the client monthly financial snapshot.');
  }

  const queryParam = {date, month};

  // Pagination cursor is optional; DynamoDB may hand back either a string or an object,
  // so serialize objects before they hit the query string.
  if (lastEvaluatedKey) {
    queryParam.lastEvaluatedKey = typeof lastEvaluatedKey === 'string' ?
      lastEvaluatedKey :
      JSON.stringify(lastEvaluatedKey);
  }

  const url = getMetricsUrl('/metrics/financial/client-monthly-snapshot', queryParam);

  return backend.get(url);
};

// Agent report card rollups live in the AgentCore Engine API, not the metrics
// service, but share the metrics repo's daily_count date grammar.
const queryAgentReportCardMetrics = (dates, guideRn) => {
  const queryParam = {
    dates: dates.join(','),
    guideRn,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${AGENTCORE_ENGINE_API}/metrics/agent_report_card?${query}`;

  return backend.get(url);
};

export default {
  queryAgentReportCardMetrics,
  queryClientMonthlyFinancialSnapshot,
  queryDailyClientMetrics,
  queryDailyClientLogsMetrics,
  queryFinancialSnapshots,
};
